import {
  Box,
  Button,
  Card,
  CardContent,
  CardMedia,
  Chip,
  Grid,
  ImageList,
  ImageListItem,
  Typography,
} from "@mui/material";
import React from "react";
import ProductCard from "./ProductCard";
import { useNavigate } from "react-router-dom";
import { useProductStore } from "../store/productStore";
import { Product } from "../types/product";
import { slugify } from "../utils/generalFunction";
import { COLORS } from "../constants/constants";

interface ProductListProps {
  title: { name: string; link: string };
  categories: string[];
  bannerImage: string;
  featuredProducts: Product[];
}

const ProductList: React.FC<ProductListProps> = (props) => {
  const navigate = useNavigate();
  return (
    <Box className="px-3 md:px-10 py-2">
      <Box className=" block md:flex justify-between items-center w-full">
        <Box className="w-full md:w-1/5 flex justify-start">
          <Typography className="text-primary_blue !size-sm font-semibold">
            {props.title.name}
          </Typography>
        </Box>
        <Box
          className="w-full md:w-4/5 relative overflow-x-auto py-2
               [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]"
        >
          <Box className="flex gap-2 flex-nowrap justify-end min-w-max">
            {props.categories.map((category) => (
              <Button
                key={slugify(props.title.name) + category.toLocaleLowerCase()}
                sx={{ textTransform: "none" }}
                variant="outlined"
                className=" !flex-shrink-0 !size-sm  whitespace-nowrap px-4 py-2  border-primary_blue rounded-lg  !text-primary_blue hover:bg-primary_blue transition-colors duration-300 hover:!text-white "
                href={
                  "products?category=" +
                  slugify(props.title.name) +
                  "&brand=" +
                  category.toLocaleLowerCase()
                }
              >
                {category}
              </Button>
            ))}
          </Box>
        </Box>
      </Box>
      <img
        src={props.bannerImage}
        alt="Hero Desktop"
        className="w-full h-auto !p-0 !m-0 !rounded-lg !mb-2"
      />

      <ImageList
        className="w-full py-10"
        variant="masonry"
        sx={{
          columnCount: {
            xs: "2 !important",
            sm: "4 !important",
            md: "5 !important",
          },
          columnGap: {
            xs: "8px !important",
            sm: "12px !important",
            md: "16px !important",
          },
          rowGap: {
            xs: "8px !important",
            sm: "12px !important",
            md: "16px !important",
          },
        }}
      >
        {props.featuredProducts.map((item) => (
          <ImageListItem
            key={`${Date.now().toString(36)}-${Math.random()
              .toString(36)
              .substring(2, 6)}`}
          >
            <ProductCard
              key={`product-card-${item.id}`}
              product={item}
              onClick={() => {
                navigate(`/product-detail/${item.id}`);
                window.scrollTo({ top: 0, behavior: "smooth" });
              }}
            />
          </ImageListItem>
        ))}
      </ImageList>

      <Box sx={{ mt: 3, textAlign: "center" }}>
        <Button
          href={"products?category=" + slugify(props.title.name)}
          className=" lg:flex !text-base !bg-primary_blue !text-white !px-4 !py-2"
          variant="contained"
          sx={{
            textTransform: "none",
            backgroundColor: COLORS.primary_blue,
            "&:hover": { backgroundColor: "#2DAE58" },
          }}
        >
          Xem tất cả {props.title.name.toLocaleLowerCase()}
        </Button>
      </Box>
    </Box>
  );
};

export default ProductList;
